import React from 'react';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { SubTitle } from 'components/atoms/Texts/SubTitle';
import { MyClassBlock } from 'components/molecules/Blocks/MyClassBlock';
import { ClasseRank } from '../../../../types/classe/classeRank';
import useStyle from './featureMyClass.styles';

export interface FeatureMyClassViewProps {
  rank: ClasseRank;
  amountCommission: number;
  percentOfCommission: number;
  classe: string;
}

export const FeatureMyClassView = ({
  rank,
  amountCommission,
  percentOfCommission,
  classe
}: FeatureMyClassViewProps) => {
  const classes = useStyle();
  return (
    <FeatureContainer>
      <SubTitle text={`Ma Classe  (${classe})`} />
      <MyClassBlock
        title={"Position au national (chiffre d'affaires)"}
        text={
          <p className={classes.position}>
            {rank.rank}
            {' sur '}
            {rank.totalClasses}
          </p>
        }
        variant={'classRank'}
      />
      <MyClassBlock
        title={'Commission ' + percentOfCommission + ' %'}
        text={amountCommission + ' €'}
        variant={'commission'}
      />
    </FeatureContainer>
  );
};
